import * as React from "react";
const SvgFiRrLandLocation = (props) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    fill="none"
    viewBox="0 0 24 24"
    {...props}
  >
    <g clipPath="url(#fi-rr-land-location_svg__a)">
      <path
        fill="#062147"
        d="M9.553 14.397a3.5 3.5 0 0 0 2.447.99 3.5 3.5 0 0 0 2.447-.99l2.502-2.448a6.96 6.96 0 0 0 2.05-4.95c0-1.87-.728-3.627-2.05-4.95a6.95 6.95 0 0 0-4.95-2.05c-1.87 0-3.626.728-4.95 2.05-2.728 2.729-2.728 7.17.009 9.907zM8.465 3.464A4.97 4.97 0 0 1 12 2c1.336 0 2.59.52 3.535 1.464A4.97 4.97 0 0 1 17 7a4.96 4.96 0 0 1-1.457 3.528l-2.494 2.44a1.51 1.51 0 0 1-2.098 0l-2.487-2.432A4.97 4.97 0 0 1 7 7a4.97 4.97 0 0 1 1.464-3.536M9 6.99a3 3 0 1 1 6 0 3 3 0 0 1-6 0m14.945 12.353-1-6a3.97 3.97 0 0 0-1.144-2.198 1 1 0 0 0-1.414.015 1 1 0 0 0 .014 1.414c.304.297.5.677.57 1.097L21.36 16H2.639l.388-2.329c.075-.447.3-.86.639-1.161a1 1 0 1 0-1.333-1.491 4 4 0 0 0-1.278 2.324l-1 5.999a3.99 3.99 0 0 0 .893 3.243A4 4 0 0 0 4 24h16a3.996 3.996 0 0 0 3.945-4.657M14.948 18l.557 4H8.494l.556-4zM2.473 21.293a2 2 0 0 1-.446-1.622L2.306 18h4.726l-.556 4H4a2 2 0 0 1-1.527-.707m19.052 0A2 2 0 0 1 20 22h-2.476l-.557-4h4.727l.279 1.671a2 2 0 0 1-.448 1.622"
      />
    </g>
    <defs>
      <clipPath id="fi-rr-land-location_svg__a">
        <path fill="#fff" d="M0 0h24v24H0z" />
      </clipPath>
    </defs>
  </svg>
);
export default SvgFiRrLandLocation;
